import BetaLabel from '../BetaLabel/BetaLabel'
import { JagadLogo } from '../JagadLogo/JagadLogo'

import { Container } from './JagadBeta.styles'

const JagadBeta = () => {
  return (
    <Container>
        <div>
            <JagadLogo type="logo-black-text-black" size={100} />
        </div>
        <div>
            <BetaLabel size="small" />
        </div>
    </Container>
  )
}

export default JagadBeta
